import React from 'react';
import { Space, Text, Conditional } from '@cashfree-intl/coherent';
import { CURRENCY_SYMBOL } from 'utils/constants';
import { roundOffNumber } from 'utils/common';
import { TooltipContent } from './styled';

const AmountBreakdown = ({ data, content }: { data: any; content: any }) => (
  <TooltipContent>
    {content.map((obj, index) => (
      <>
        <Space
          alignItems="center"
          justifyContent="space-between"
          key={obj.key}
          className={index < content.length - 1 ? 'mb-1' : ''}
        >
          <Text color="bodyLight" variant="b12">
            {obj.display}
          </Text>
          <Text variant="b12">
            {data[obj.key] > 0 && obj.isNegative ? '- ' : ''}
            {CURRENCY_SYMBOL.INR} {roundOffNumber(data[obj.key] || 0)}
          </Text>
        </Space>
        <Conditional if={index === content.length - 2}>
          <div className="divider mb-1" />
        </Conditional>
      </>
    ))}
  </TooltipContent>
);

export default AmountBreakdown;
